import { DoubleRightOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row } from "antd";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import API_CHART from "../../api/backend/dynamicChart";
import { KEY, lang } from "../../constants/common.const";
import { enterSearch, MSG_CATCH, showMessage } from "../../constants/utils";
import classText from "../../models/control/text";
import ListItemIoT from "./ListItemIoT";
import RowInput from "../Desktop/rowInput2";
import { useDispatch, useSelector } from "react-redux";
import { setListItemIoT } from "../../redux/chart";
export default function BoxSearchItemIoT({
  setLoading,
  listFilter,
  checkedList: chkList,
  ...other
}) {
  const [txtIoTNameSearch, setTxtIoTNameSearch] = useState(
    new classText("")
  );
  const [ioTListSearch, setIoTListSearch] = useState([]);
  const [checkedList, setCheckedList] = chkList;

  // list Item IOT -  fetch 1 lan
  const { listItemIoT } = useSelector((state) => state.chart);
  const dispatch = useDispatch();

  const closeLoadingSpinner = () => setLoading(false);
  const openLoadingSpinner = () => setLoading(true);

  useEffect(() => {
    
    searchListItemIOT(other.defaultValue);
  }, [other.defaultValue]);

  // Search : Search Machine where ...
  function searchListItemIOT(name) {
    let txtSearch =
       txtIoTNameSearch.value && txtIoTNameSearch.value.trim();
    // Call api
    if (listItemIoT && Array.isArray(listItemIoT)) {
      setIoTListSearch(
        listItemIoT.filter((i) => i.checkItemName.includes(txtSearch))
      );
      return;
    }

    // Fetch Data
    API_CHART.getListItemIOT({})
      .then((res) => {
        // Case: Init search
        setIoTListSearch(
          res.data.filter((i) => i.checkItemName.includes(txtSearch))
        );
        dispatch(setListItemIoT(res.data));
      })
      .catch((xhr) => {
        showMessage(KEY.ERROR, MSG_CATCH());
      })
      .then(() => {
        // Close loading
        closeLoadingSpinner();
      });
  }
  useEffect(() => {
    return () => {
      dispatch(setListItemIoT(null));
    };
  }, []);

  return (
    <Row>
      <Col lg={6} xs={24}>
        <Form layout={"vertical"} className="formDes">
          <RowInput className="mb10" name="">
            <Input
              value={txtIoTNameSearch.value}
              placeholder="機器名"
              style={{
                width: "calc(100% - 87px)",
              }}
              onChange={(e) =>
                setTxtIoTNameSearch({
                  ...txtIoTNameSearch,
                  value: e.target.value,
                })
              }
              {...enterSearch(searchListItemIOT)}
            />
            {/* Button search 検索*/}
            <Button
              className="buttonPC button--info wAuto ml5"
              onClick={() => {
                searchListItemIOT();
              }}
            >
              <SearchOutlined className="" /> {lang.SEARCH}
            </Button>
          </RowInput>
        </Form>
      </Col>
      {/* From */}
      <Col lg={2} xs={0}>
        <DoubleRightOutlined
          style={{
            fontSize: "60px",
            color: "#b9b9b9",
            width: "100%",
            margin: "200px 0 0",
          }}
        />
      </Col>
      {/* To */}
      <Col lg={16} xs={24}>
        <div className="box-select-row">
          <ListItemIoT
            loadMore={() => {
              searchListItemIOT();
            }}
            style={{
              overflow: "hidden",
              height: "100%",
              overflowY: "auto",
            }}
            listFilter={listFilter}
            options={ioTListSearch}
            checkedList={checkedList}
            onCheck={(arrChecked) => {
              other.isOneValue
                ? setCheckedList(
                    !isEmpty(arrChecked)
                      ? [arrChecked[arrChecked.length - 1]]
                      : []
                  )
                : setCheckedList(JSON.parse(JSON.stringify(arrChecked)));
            }}
          ></ListItemIoT>
        </div>
      </Col>
    </Row>
  );
}
